/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback } from 'react';
import {
  CardBody,
  Row,
  Col,
  Card,
  Container,
  CardHeader,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Label,
  Input,
  Button,
} from 'reactstrap';
import DataTable from 'react-data-table-component';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import DeleteModal from '../../Components/Common/DeleteModal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import Select from 'react-select';
import { api } from '../../config';
import { getAuthToken } from '../../auth/tokenvalidation';

const IncotermLocationList = () => {
  const token = getAuthToken();

  const [data, setData] = useState({ items: [] });
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [invoice, setInvoice] = useState(null);
  const [errors, setErrors] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [modalIncotermLocation, setModalIncotermLocation] = useState(false);
  const [incotermLocationFormData, setIncotermLocationFormData] = useState({
    incotermRouteId: '',
    locationId: '',
    description: '',
    isLpgCase: null,
    id: null,
  });

  const [filterText, setFilterText] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [incotermRoutes, setIncotermRoutes] = useState([]);
  const [selectedIncotermRoute, setSelectedIncotermRoute] = useState('');
  const [selectedIncotermType, setSelectedIncotermType] = useState('');
  const [locationOptions, setLocationOptions] = useState([]);

  const handleDeleteModal = id => {
    const selectedRow = data.items.find(item => item.id === id);
    setInvoice(selectedRow);
    setDeleteModal(true);
  };

  const handleDeleteInvoice = async () => {
    if (invoice) {
      try {
        const response = await fetch(
          `${api.API_URL}/incoterm-location/${invoice.id}`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.message || `HTTP error! status: ${response.status}`
          );
        }

        toast.success('Incoterm Location berhasil dihapus!', {
          autoClose: 3000,
        });
        setDeleteModal(false);
        setInvoice(null);
        const filters = {
          incotermRouteId: selectedIncotermRoute,
          searchText: filterText,
        };
        fetchData(currentPage, rowsPerPage, token, filters);
      } catch (err) {
        toast.error(`Gagal menghapus incoterm location: ${err.message}`, {
          autoClose: 3000,
        });
      }
    }
  };

  const deleteMultiple = () => {
    // Implement multiple delete functionality
    // This would typically involve deleting selected items
    // For now, just close the modal
    setDeleteModalMulti(false);
  };

  const columns = [
    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Location Name
        </span>
      ),
      selector: row => row.name,
      sortable: true,
      width: '20%',
      wrap: true,
      cell: row => {
        return (
          <>
            <h6 className={'mb-0'}>{row.name}</h6>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Incoterm Route
        </span>
      ),
      selector: row => row.incotermRoute?.name,
      sortable: true,
      width: '20%',
      wrap: true,
      cell: row => {
        return (
          <>
            <h6 className={'mb-0'}>{row.incotermRoute?.name || '-'}</h6>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Incoterm
        </span>
      ),
      selector: row => row.incotermRoute?.incoterm?.name,
      sortable: true,
      width: '15%',
      wrap: true,
      cell: row => {
        return (
          <>
            <h6 className={'mb-0'}>
              {row.incotermRoute?.incoterm?.name || '-'}
            </h6>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Description
        </span>
      ),
      selector: row => row.description,
      sortable: true,
      width: '25%',
      wrap: true,
      cell: row => {
        return (
          <>
            <h6 className={'mb-0'}>{row.description || '-'}</h6>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          LPG Case
        </span>
      ),
      selector: row => row.isLpgCase,
      sortable: true,
      width: '10%',
      wrap: true,
      centered: true,
      cell: row => {
        return (
          <>
            <span
              className={` ${
                row.isLpgCase === null
                  ? ''
                  : row.isLpgCase
                    ? ' badge bg-success'
                    : 'badge bg-secondary'
              }`}
            >
              {row.isLpgCase === null ? '-' : row.isLpgCase ? 'Yes' : 'No'}
            </span>
          </>
        );
      },
    },

    {
      name: (
        <span className='form-label  text-uppercase fw-semibold fs-13'>
          Action
        </span>
      ),
      width: '10%',
      sortable: false,
      className: 'text-end',
      cell: row => (
        <div className='d-flex gap-1 justify-content-end'>
          <button
            className='btn btn-soft-info btn-sm btn-icon'
            onClick={() => handleUpdateModal(row.id)}
          >
            <i className='ri-pencil-fill align-bottom'></i>
          </button>
          <button
            className='btn btn-soft-danger btn-sm btn-icon'
            onClick={() => handleDeleteModal(row.id)}
          >
            <i className='ri-delete-bin-6-line align-bottom'></i>
          </button>
        </div>
      ),
    },
  ];

  document.title = 'Data Incoterm Location';

  const handleChange = e => {
    const { name, value } = e.target;
    setIncotermLocationFormData({ ...incotermLocationFormData, [name]: value });
  };

  // API returns restrictions with 4 decimals (e.g. 110000.0000, 12.5000).
  const formatRestriction = value => {
    if (value === null || value === undefined || value === '') return '-';
    const num = Number(value);
    return Number.isNaN(num)
      ? '-'
      : num.toLocaleString('en-US', { maximumFractionDigits: 2 });
  };

  useEffect(() => {
    const filters = {
      incotermRouteId: selectedIncotermRoute,
      searchText: filterText,
    };
    fetchData(currentPage, rowsPerPage, token, filters);
    fetchIncotermRoutes(token);
    fetchLocations(token);
  }, [currentPage, rowsPerPage, token, selectedIncotermRoute, filterText]);

  // Initialize filteredData when data changes
  useEffect(() => {
    if (data.items && data.items.length > 0) {
      setFilteredData(data.items);
    }
  }, [data.items]);

  // Filter data based on selected filters (only client-side filters now)
  useEffect(() => {
    let filtered = data.items || [];

    // Only filter by Incoterm Type on client side
    // (incotermRouteId and text search are now handled server-side)
    if (selectedIncotermType) {
      filtered = filtered.filter(
        item =>
          item.incotermRoute?.incotermId === selectedIncotermType ||
          item.incotermRoute?.incoterm?.id === selectedIncotermType
      );
    }

    setFilteredData(filtered);
  }, [data.items, selectedIncotermType]);

  const handleFilterChange = e => {
    setFilterText(e.target.value);
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handleIncotermRouteFilterChange = e => {
    setSelectedIncotermRoute(e.target.value);
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handleIncotermTypeFilterChange = e => {
    setSelectedIncotermType(e.target.value);
  };

  const clearAllFilters = () => {
    setFilterText('');
    setSelectedIncotermRoute('');
    setSelectedIncotermType('');
    setCurrentPage(1); // Reset to first page when clearing filters
  };

  const fetchData = async (currentPage, rowsPerPage, token, filters = {}) => {
    setLoading(true);
    try {
      // Build query parameters
      const queryParams = new URLSearchParams({
        PageNumber: currentPage.toString(),
        PageSize: rowsPerPage.toString(),
      });

      // Add filter parameters if they exist
      if (filters.incotermRouteId) {
        queryParams.append('IncotermRouteId', filters.incotermRouteId);
      }
      if (filters.searchText) {
        queryParams.append('Name', filters.searchText);
      }

      const url = `${api.API_URL}/incoterm-location?${queryParams.toString()}`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      // Handle different possible response structures
      const items =
        result?.data?.items || result?.items || result?.data || result || [];
      const totalItems =
        result?.data?.totalItems || result?.totalItems || items.length;

      setData({
        items: Array.isArray(items) ? items : [],
      });
      setTotalRows(totalItems);
    } catch (error) {
      toast.error(`Failed to load data: ${error.message}`);
      setData({ items: [] });
      setTotalRows(0);
    } finally {
      setLoading(false);
    }
  };

  const fetchIncotermRoutes = async token => {
    try {
      const response = await fetch(
        `${api.API_URL}/incoterm/get-incoterm-route`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          credentials: 'same-origin',
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      const items =
        result?.data?.items || result?.items || result?.data || result || [];
      setIncotermRoutes(Array.isArray(items) ? items : []);
    } catch (error) {
      toast.error(`Failed to load incoterm routes: ${error.message}`);
      setIncotermRoutes([]);
    }
  };

  const fetchLocations = async token => {
    try {
      const queryParams = new URLSearchParams({
        PageNumber: 1,
        PageSize: 300,
        SortBy: 'Name',
        IsDescending: false,
      });

      const response = await fetch(
        `${api.API_URL}/location?${queryParams.toString()}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          credentials: 'same-origin',
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      const items =
        result?.data?.items || result?.items || result?.data || result || [];
      setLocationOptions(
        (Array.isArray(items) ? items : []).map(item => ({
          value: item.id,
          label: item.name,
        }))
      );
    } catch (error) {
      toast.error(`Failed to load locations: ${error.message}`);
      setLocationOptions([]);
    }
  };

  const handlePageChange = useCallback(
    page => {
      // If only incoterm type filter is active (client-side), don't change server page
      // Server-side filters (incotermRoute, text search) can still use server pagination
      if (!selectedIncotermType) {
        setCurrentPage(page);
      }
    },
    [selectedIncotermType]
  );

  const handlePerRowsChange = useCallback(
    newPerPage => {
      setRowsPerPage(newPerPage);
      // Only reset page if no client-side filters are active
      if (!selectedIncotermType) {
        setCurrentPage(1);
      }
    },
    [selectedIncotermType]
  );

  const handleNewModal = () => {
    setIncotermLocationFormData({
      incotermRouteId: '',
      locationId: '',
      description: '',
      isLpgCase: null,
      id: null,
    });
    incotermLocationModal();
  };

  const handleUpdateModal = (mid = null) => {
    fetchIncotermLocationDetail(mid);

    incotermLocationModal();
  };

  const incotermLocationModal = () => {
    setModalIncotermLocation(!modalIncotermLocation);
  };

  const selectedFieldsIncotermLocation = {
    incotermRouteId: incotermLocationFormData.incotermRouteId,
    locationId: incotermLocationFormData.locationId,
    description: incotermLocationFormData.description,
    isLpgCase: incotermLocationFormData.isLpgCase,
  };

  const handleAddDataIncotermLocation = async () => {
    try {
      await axios.post(
        `${api.API_URL}/incoterm-location`,
        selectedFieldsIncotermLocation,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Incoterm Location Has been Added`);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
    } finally {
      const filters = {
        incotermRouteId: selectedIncotermRoute,
        searchText: filterText,
      };
      fetchData(currentPage, rowsPerPage, token, filters);
    }
  };

  const fetchIncotermLocationDetail = async mid => {
    try {
      const response = await axios.get(
        `${api.API_URL}/incoterm-location/${mid}`,
        {
          withXSRFToken: true,
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: `application/json`,
          },
        }
      );
      // The global axios interceptor (src/helpers/api_helper.js) already unwraps
      // `response.data`, so `response` is the `{ success, message, data }` envelope.
      // Peel one more level, tolerating either shape.
      const data = response?.data?.data ?? response?.data ?? response;
      setIncotermLocationFormData({
        incotermRouteId: data.incotermRouteId || '',
        locationId: data.locationId || '',
        description: data.description || '',
        isLpgCase: data.isLpgCase,
        id: data.id || null,
      });
    } catch (error) {
      // Handle error silently or show appropriate message
      toast.error(
        `Failed to fetch incoterm location details: ${error.message}`
      );
    }
  };

  const handleUpdDataIncotermLocation = async mid => {
    try {
      await axios.put(
        `${api.API_URL}/incoterm-location/${mid}`,
        selectedFieldsIncotermLocation,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(`Data Has been Updated`);
    } catch (error) {
      toast.error(`Failed to save data: ${error.message}`);
    } finally {
      const filters = {
        incotermRouteId: selectedIncotermRoute,
        searchText: filterText,
      };
      fetchData(currentPage, rowsPerPage, token, filters);
    }
  };

  return (
    <React.Fragment>
      <div className='page-content'>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={() => handleDeleteInvoice()}
          onCloseClick={() => setDeleteModal(false)}
        />
        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        />
        <Container fluid>
          <BreadCrumb title='View Data' pageTitle='Incoterm Location' />

          <Row>
            <Col lg={12}>
              <Card id='IncotermLocationList'>
                <CardHeader className='border-0'>
                  <div className='d-flex align-items-center'>
                    <h5 className='card-title mb-0 flex-grow-1'>
                      Data Incoterm Location
                    </h5>
                    <div className='flex-shrink-0'>
                      <div className='d-flex gap-2 flex-wrap'>
                        <button
                          type='button'
                          className='btn btn-primary btn-label right ms-auto nexttab btn-sm'
                          onClick={() => handleNewModal()}
                        >
                          <i className='ri-play-list-add-line label-icon align-middle fs-16 ms-2'></i>{' '}
                          <span className='d-none d-sm-inline'>
                            Create New Incoterm Location
                          </span>
                          <span className='d-sm-none'>New</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Filter Section */}
                  <div className='mt-3'>
                    <Row>
                      <Col md={4}>
                        <div className='d-flex align-items-center gap-2'>
                          <Input
                            type='text'
                            placeholder='Search incoterm locations...'
                            value={filterText}
                            onChange={handleFilterChange}
                            className='form-control-sm'
                          />
                        </div>
                      </Col>
                      <Col md={3}>
                        <Input
                          type='select'
                          value={selectedIncotermRoute}
                          onChange={handleIncotermRouteFilterChange}
                          className='form-control-sm'
                        >
                          <option value=''>All Incoterm Routes</option>
                          {incotermRoutes.map(route => (
                            <option key={route.id} value={route.id}>
                              {route.incoterm?.name} - {route.name}
                            </option>
                          ))}
                        </Input>
                      </Col>
                      <Col md={2}>
                        {(filterText ||
                          selectedIncotermRoute ||
                          selectedIncotermType) && (
                          <Button
                            color='secondary'
                            size='sm'
                            onClick={clearAllFilters}
                            outline
                          >
                            <i className='ri-close-line'></i> Clear All
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </div>
                </CardHeader>

                <CardBody className='pt-0'>
                  <div
                    className='table-responsive'
                    style={{
                      minHeight: 'auto',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <DataTable
                      columns={columns}
                      highlightOnHover
                      data={selectedIncotermType ? filteredData : data.items}
                      pagination
                      paginationServer={!selectedIncotermType}
                      paginationTotalRows={
                        selectedIncotermType ? filteredData.length : totalRows
                      }
                      onChangePage={handlePageChange}
                      onChangeRowsPerPage={handlePerRowsChange}
                      showPaginationBottom={true}
                      wrap
                      dense
                      striped
                      progressPending={loading}
                      fixedHeader={false}
                      fixedHeaderScrollHeight={undefined}
                      noDataComponent={
                        <div
                          style={{
                            padding: '20px',
                            textAlign: 'center',
                            color: '#6c757d',
                          }}
                        >
                          <i
                            className='ri-database-2-line'
                            style={{
                              fontSize: '32px',
                              marginBottom: '8px',
                              display: 'block',
                            }}
                          ></i>
                          {filterText ||
                          selectedIncotermRoute ||
                          selectedIncotermType
                            ? 'No incoterm locations match the current filters'
                            : 'No incoterm locations found'}
                        </div>
                      }
                      defaultSortFieldId={1}
                      defaultSortAsc={true}
                      customStyles={{
                        header: {
                          style: {
                            backgroundColor: '#f0f0f0',
                            color: '#333',
                            fontWeight: 'bold',
                          },
                        },
                        headCells: {
                          style: {
                            backgroundColor: '#f0f0f0',
                            fontWeight: 'bold',
                            fontSize: '14px',
                            paddingLeft: '12px',
                            paddingRight: '12px',
                            borderRight: '1px solid #dee2e6',
                          },
                        },
                        cells: {
                          style: {
                            paddingLeft: '12px',
                            paddingRight: '12px',
                            wordBreak: 'break-word',
                            borderRight: '1px solid #dee2e6',
                          },
                        },
                        rows: {
                          style: {
                            minHeight: '50px',
                            '&:hover': {
                              backgroundColor: '#f8f9fa',
                            },
                          },
                        },
                        table: {
                          style: {
                            width: '100%',
                            minWidth: '100%',
                            tableLayout: 'fixed',
                          },
                        },
                        responsiveWrapper: {
                          style: {
                            overflowX: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                          },
                        },
                        pagination: {
                          style: {
                            borderTop: '1px solid #dee2e6',
                            backgroundColor: '#f8f9fa',
                            margin: 0,
                            padding: '8px 0',
                          },
                        },
                      }}
                    />

                    <ToastContainer closeButton={false} limit={1} />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal
            isOpen={modalIncotermLocation}
            role='dialog'
            autoFocus={true}
            centered
            id='addIncotermLocationModal'
            toggle={incotermLocationModal}
            // data-bs-backdrop='static'
            // size='lg'
            // style={{ maxWidth: '960px' }}
            data-bs-backdrop='static'
            size='lg'
            zIndex={1060}
          >
            <ModalHeader
              className='bg-soft-info'
              toggle={() => {
                setModalIncotermLocation(!modalIncotermLocation);
              }}
            >
              <span className='modal-title text-info fw-bold'>
                {incotermLocationFormData.id !== null
                  ? 'Edit Incoterm Location'
                  : 'Add Incoterm Location'}
              </span>
            </ModalHeader>

            <ModalBody>
              <div className='d-flex mt-2'>
                <Col sm={12}>
                  <Row>
                    <Col sm={6}>
                      <div className='mb-3'>
                        <Label for='incoterm-route' className='form-label '>
                          Incoterm Route :
                        </Label>
                        <div className='input-group'>
                          <Input
                            type='select'
                            id='incotermRouteId'
                            name='incotermRouteId'
                            className='form-control'
                            value={
                              incotermLocationFormData.incotermRouteId || ''
                            }
                            onChange={e => {
                              handleChange(e);
                              setErrors({
                                ...errors,
                                incotermRouteId: '',
                              });
                            }}
                          >
                            <option value=''>Select Incoterm Route</option>
                            {incotermRoutes.map(route => (
                              <option key={route.id} value={route.id}>
                                {route.incoterm?.name} - {route.name}
                              </option>
                            ))}
                          </Input>
                        </div>
                      </div>
                    </Col>
                    <Col sm={6}>
                      <div className='mb-3'>
                        <Label for='lpg-case' className='form-label '>
                          LPG Case :
                        </Label>
                        <div className='input-group'>
                          <Input
                            type='select'
                            id='isLpgCase'
                            name='isLpgCase'
                            className='form-control'
                            value={
                              incotermLocationFormData.isLpgCase === null
                                ? ''
                                : incotermLocationFormData.isLpgCase.toString()
                            }
                            onChange={e => {
                              const value =
                                e.target.value === ''
                                  ? null
                                  : e.target.value === 'true';
                              setIncotermLocationFormData({
                                ...incotermLocationFormData,
                                isLpgCase: value,
                              });
                              setErrors({
                                ...errors,
                                isLpgCase: '',
                              });
                            }}
                          >
                            <option value=''>Select LPG Case</option>
                            <option value='true'>Yes</option>
                            <option value='false'>No</option>
                          </Input>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12}>
                      <div className='mb-3'>
                        <Label for='location-id' className='form-label '>
                          Location :
                        </Label>
                        <Select
                          id='location-id'
                          options={locationOptions}
                          value={
                            locationOptions.find(
                              opt =>
                                opt.value ===
                                incotermLocationFormData.locationId
                            ) || null
                          }
                          onChange={selected => {
                            setIncotermLocationFormData(prev => ({
                              ...prev,
                              locationId: selected?.value || '',
                            }));
                            setErrors({
                              ...errors,
                              locationId: '',
                            });
                          }}
                          placeholder='Select Location'
                          isSearchable
                          isClearable
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              borderColor: errors.locationId
                                ? '#dc3545'
                                : baseStyles.borderColor,
                              boxShadow: errors.locationId
                                ? '0 0 0 0.25rem rgba(220, 53, 69, 0.25)'
                                : baseStyles.boxShadow,
                            }),
                          }}
                        />
                        {errors.locationId && (
                          <div className='invalid-feedback d-block'>
                            {errors.locationId}
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12}>
                      <div className='mb-3'>
                        <Label htmlFor='description' className='form-label'>
                          Description{' '}
                        </Label>
                        <textarea
                          className='form-control'
                          id='description'
                          name='description'
                          rows='3'
                          value={incotermLocationFormData.description || ''}
                          onChange={e => {
                            handleChange(e);
                            setErrors({
                              ...errors,
                              description: '',
                            });
                          }}
                        ></textarea>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </div>
            </ModalBody>

            <ModalFooter>
              <Button
                color='danger'
                className='btn-label btn-sm right'
                onClick={() => {
                  setModalIncotermLocation(!modalIncotermLocation);
                }}
              >
                {' '}
                <i className=' ri-close-circle-line label-icon align-middle fs-16 ms-2'></i>{' '}
                Close
              </Button>
              <Button
                color='primary'
                className='btn-label btn-sm right'
                onClick={() => {
                  setModalIncotermLocation(!modalIncotermLocation);
                  incotermLocationFormData.id !== null
                    ? handleUpdDataIncotermLocation(incotermLocationFormData.id)
                    : handleAddDataIncotermLocation();
                }}
              >
                {' '}
                <i className='ri-database-2-line label-icon align-middle fs-16 ms-2'></i>{' '}
                {incotermLocationFormData.id !== null ? 'Update' : 'Save'}
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default IncotermLocationList;
